import { rootRef } from './firebase';
import { upsertPeerCommentsToReport } from './peerReportSummary';
import { peerCommentDocId, peerContribDocId } from './evalYear';

export type PeerSubmitStatus = 'draft' | 'submitted';

function contribRef(year: number, evaluatorId: string, colleagueId: string) {
  return rootRef().collection('peer_eval_contribs').doc(peerContribDocId(year, evaluatorId, colleagueId));
}

function commentRef(year: number, evaluatorId: string, colleagueId: string) {
  return rootRef().collection('peer_comments').doc(peerCommentDocId(year, evaluatorId, colleagueId));
}

export function isPeerEvalSubmitted(status: unknown): boolean {
  return status === 'submitted';
}

/** 제출 완료 여부 (contrib 또는 comments의 status) */
export async function fetchPeerEvalSubmitted(
  evalYear: number,
  evaluatorId: string,
  colleagueId: string
): Promise<boolean> {
  const [cSnap, mSnap] = await Promise.all([
    contribRef(evalYear, evaluatorId, colleagueId).get(),
    commentRef(evalYear, evaluatorId, colleagueId).get(),
  ]);
  if (isPeerEvalSubmitted(cSnap.data()?.status)) return true;
  if (isPeerEvalSubmitted(mSnap.data()?.status)) return true;
  return false;
}

/**
 * 최종 제출: 코멘트 반영 + 제출 잠금.
 * 이후 동일 연도 evaluator-colleague 쌍은 수정 불가 (HR 제외).
 */
export async function submitPeerEvaluation(
  evalYear: number,
  evaluatorId: string,
  colleagueId: string,
  colleagueName: string,
  strength: string,
  improvement: string
): Promise<void> {
  const already = await fetchPeerEvalSubmitted(evalYear, evaluatorId, colleagueId);
  if (already) {
    throw new Error('ALREADY_SUBMITTED');
  }

  const now = Date.now();
  const strengthTrim = (strength || '').trim();
  const improvementTrim = (improvement || '').trim();

  await upsertPeerCommentsToReport(evalYear, evaluatorId, colleagueId, strengthTrim, improvementTrim);

  await Promise.all([
    commentRef(evalYear, evaluatorId, colleagueId).set(
      {
        evalYear,
        evaluatorId,
        colleagueId,
        colleagueName,
        strength: strengthTrim,
        improvement: improvementTrim,
        status: 'submitted',
        submittedAt: now,
        updatedAt: now,
      },
      { merge: true }
    ),
    contribRef(evalYear, evaluatorId, colleagueId).set(
      {
        evalYear,
        evaluatorId,
        colleagueId,
        status: 'submitted',
        submittedAt: now,
        updatedAt: now,
      },
      { merge: true }
    ),
  ]);
}
